import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let inflight = null;

export const fetchDefaultPrices = async () => {
    if (cache) return cache;
    if (!inflight) {
        inflight = axios.get(`${API}/category-defaults`).then(({ data }) => {
            const map = {};
            (data || []).forEach((d) => (map[d.key] = d.price_cents));
            cache = map;
            return map;
        }).catch(() => ({})).finally(() => { inflight = null; });
    }
    return inflight;
};

export const resolveDefaultPrice = (priceMap, category, subcategory) => {
    if (!priceMap) return null;
    const subKey = `${category}/${subcategory}`;
    if (subKey in priceMap) return priceMap[subKey];
    if (category in priceMap) return priceMap[category];
    return null;
};

export const useDefaultPrices = () => {
    const [map, setMap] = useState(cache || {});
    useEffect(() => {
        fetchDefaultPrices().then(setMap);
    }, []);
    return map;
};
